module.exports = __webpack_public_path__ + "img/reset-step-three3.b67657a9.png";